import {useCallback, useEffect} from "react";
import {useSignal} from "@preact/signals-react";
import {getSubmit} from "@ui-seeker/utils";

import {BACKEND_APIS} from "@constants";
import {useAppToast} from "@ui-seeker/app";


export default function useMatchersAttributes(skuID, productID, siteID) {
	const showAttrs = useSignal(false)
	const isLoading = useSignal(false)
	const attributes = useSignal(null)

	const { showToast } = useAppToast()

	useEffect(() => {
		showAttrs.value = false
		attributes.value = null
	}, [skuID, productID, siteID]);

	const handleClick = useCallback(() => {
		if (attributes.value === null) {
			const url = skuID
				? `${BACKEND_APIS.MATCHERS}/skus/attributes/${skuID}`
				: `${BACKEND_APIS.MATCHERS}/skus/sku-mapping/attributes/${productID}/${siteID}`

			isLoading.value = true
			getSubmit(url).then(res => {
				attributes.value = res
				isLoading.value = false
			}).catch(() => {
				showToast.error('Error loading attributes. Please, try again.')
				isLoading.value = false
			})
		}

		showAttrs.value = !showAttrs.value
	}, [skuID, productID, siteID])

	return {
		showAttrs: showAttrs.value,
		isLoading: isLoading.value,
		attributes: attributes.value,

		handleClick
	}
}